import AdsService from '@/api/admin/ads.service'

export default {
  state: {
    table: {
      pageLength: 10,

      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    statuses: [],
    adsModel: {},
    modalConfirm: {
      loading: true,
      type: 0,
      info: {},
    },
  },
  getters: {
    allAds: state => state.table,
    allAdsStatuses: state => state.statuses,
    modalConfirm: state => state.modalConfirm,
    getAdsModel: state => state.adsModel,
  },
  actions: {
    async getAds({ commit }) {
      const ads = await AdsService.getAds()
      commit('SET_ADS', ads)
      commit('SET_TOTALRECORDS', ads.totalRecords)
      commit('SET_ADS_STATUSES', ads.statuses)
      commit('SET_ADS_MODEL', ads)
    },
    async getFilteredAds({ commit }, adsObj) {
      const ads = await AdsService.getFilteredAds(adsObj)
      commit('SET_ADS', ads)
      commit('SET_TOTALRECORDS', ads.totalRecords)
      commit('SET_ADS_STATUSES', ads.statuses)
      commit('SET_ADS_MODEL', ads)
    },
  },
  mutations: {
    SET_ADS(state, ads) {
      state.table.rows = ads.ads
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_ADS_STATUSES(state, status) {
      state.statuses = status
    },
    SET_AD_TO_APPROVE_REJECT(state, filter) {
      state.modalConfirm.info = filter.data
      state.modalConfirm.type = filter.type
      state.modalConfirm.loading = false
    },
    SET_ADS_MODEL(state, ads) {
      state.adsModel = ads
    },
  },
}
